
/**
 * Config object for SystemJS
 */
const config = {
  /** 
   * Use for defaulting file endings when resolving a "folder entry" in the import map
   * e.g. System.resolve("entry/path/to/file") -> "http://some-url/path/to/file.js" 
   * if DEFAULT_RESOLVE was set to .js
   */
  DEFAULT_RESOLVE: ''
}

export function getConfig() {
  return config;
}
